import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  > div:first-child {
    padding-bottom: 0rem;
    border-bottom: none;
  }
`;
